import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-router',
  template: '<router-outlet></router-outlet>',
})
export class RouterComponent {}
